import React, { useEffect, useState } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import { getProductById } from "../api/products"; // máš už
import { updateProductMultipart } from "../api/products";

function UpdateProductPage() {
    var navigate = useNavigate();
    var params = useParams();
    var id = params.id;

    var [loading, setLoading] = useState(true);
    var [saving, setSaving] = useState(false);
    var [error, setError] = useState(null);

    var [form, setForm] = useState({
        name: "",
        price: "",
        description: "",
        category: "",
        quantity: "",
        size: "",
        wood: "",
        subcategory: "",
        imageFile: null,
        currentImageUrl: null
    });
    var [preview, setPreview] = useState(null);

    var MAX_MB = 10;

    useEffect(function () {
        document.title = "Upraviť produkt";
        loadProduct();
    }, [id]);

    function loadProduct() {
        setLoading(true);
        getProductById(id)
            .then(function (p) {
                var copy = Object.assign({}, form);
                copy.name = p.name || "";
                copy.price = p.price != null ? String(p.price) : "";
                copy.description = p.description || "";
                copy.category = p.category || "";
                copy.quantity = p.quantity != null ? String(p.quantity) : "";
                copy.size = p.size || "";
                copy.wood = p.wood || "";
                copy.subcategory = p.subcategory || "";
                copy.currentImageUrl = p.imageUrl || null;
                copy.imageFile = null;
                setForm(copy);
                setPreview(p.imageUrl || null);
            })
            .catch(function () {
                setError("Produkt sa nepodarilo načítať.");
            })
            .finally(function () {
                setLoading(false);
            });
    }

    function handleChange(e) {
        var name = e.target.name;
        var value = e.target.value;
        var copy = Object.assign({}, form);
        copy[name] = value;
        setForm(copy);
    }

    function handleFileChange(e) {
        var file = e.target.files && e.target.files[0] ? e.target.files[0] : null;

        if (file && file.size > MAX_MB * 1024 * 1024) {
            setError("Súbor je príliš veľký (max " + MAX_MB + " MB).");
            e.target.value = "";
            return;
        }

        var copy = Object.assign({}, form);
        copy.imageFile = file;
        setForm(copy);

        if (file) {
            var r = new FileReader();
            r.onloadend = function () { setPreview(r.result); };
            r.readAsDataURL(file);
        } else {
            setPreview(form.currentImageUrl);
        }
    }

    function toNumberOrNull(v) {
        var n = parseFloat(v);
        return isNaN(n) ? null : n;
    }

    function toIntOrNull(v) {
        var n = parseInt(v, 10);
        if (isNaN(n)) { return null; }
        if (n < 0) { return 0; }
        return n;
    }

    function handleSubmit(e) {
        e.preventDefault();
        setError(null);
        setSaving(true);

        var payload = {
            name: form.name,
            price: toNumberOrNull(form.price),
            description: form.description,
            category: form.category,
            quantity: toIntOrNull(form.quantity),
            size: form.size || null,
            wood: form.wood || null,
            subcategory: form.subcategory || null,
            imageFile: form.imageFile || null // ak nepríde, BE obrázok nemení
        };

        updateProductMultipart(id, payload)
            .then(function (upd) {
                // očakávame Product s id + slug
                var slug = upd && upd.slug ? upd.slug : null;
                if (slug) {
                    navigate("/produkt/" + slug);
                } else {
                    navigate("/ponuka");
                }
            })
            .catch(function (err) {
                setError(err && err.message ? err.message : "Nepodarilo sa uložiť zmeny.");
            })
            .finally(function () {
                setSaving(false);
            });
    }

    if (loading) {
        return (
            <div className="container py-4">
                <div className="text-muted">Načítavam…</div>
            </div>
        );
    }

    return (
        <div className="container py-4">
            <h1 className="h4 mb-3">Upraviť produkt</h1>
            {error && <div className="alert alert-danger">{error}</div>}

            <form onSubmit={handleSubmit} className="row g-3">
                <div className="col-md-6">
                    <label className="form-label">Názov</label>
                    <input name="name" className="form-control" value={form.name} onChange={handleChange} />
                </div>

                <div className="col-md-3">
                    <label className="form-label">Cena (€)</label>
                    <input name="price" type="number" step="0.01" className="form-control" value={form.price} onChange={handleChange} />
                </div>

                <div className="col-md-3">
                    <label className="form-label">Sklad (ks)</label>
                    <input name="quantity" type="number" min="0" step="1" className="form-control" value={form.quantity} onChange={handleChange} />
                </div>

                <div className="col-md-3">
                    <label className="form-label">Kategória</label>
                    <input name="category" className="form-control" value={form.category} onChange={handleChange} />
                </div>

                <div className="col-md-3">
                    <label className="form-label">Podkategória</label>
                    <input name="subcategory" className="form-control" value={form.subcategory} onChange={handleChange} />
                </div>

                <div className="col-md-3">
                    <label className="form-label">Veľkosť</label>
                    <input name="size" className="form-control" value={form.size} onChange={handleChange} />
                </div>

                <div className="col-md-3">
                    <label className="form-label">Drevo</label>
                    <input name="wood" className="form-control" value={form.wood} onChange={handleChange} />
                </div>

                <div className="col-12">
                    <label className="form-label">Popis</label>
                    <textarea name="description" className="form-control" rows="3" value={form.description} onChange={handleChange}></textarea>
                </div>

                <div className="col-md-6">
                    <label className="form-label">Obrázok (ak chceš nahradiť)</label>
                    <input type="file" accept="image/*" className="form-control" onChange={handleFileChange} />
                    {preview && (
                        <img src={preview} alt="Náhľad" className="img-thumbnail mt-2" style={{ maxWidth: "220px" }} />
                    )}
                    {form.currentImageUrl && !form.imageFile && (
                        <div className="form-text">Aktuálny: {form.currentImageUrl}</div>
                    )}
                </div>

                <div className="col-12 d-flex gap-2">
                    <button type="submit" className="btn btn-brown rounded-pill px-4" disabled={saving}>
                        {saving ? "Ukladám…" : "Uložiť zmeny"}
                    </button>
                    <Link to="/ponuka" className="btn btn-outline-secondary">Späť</Link>
                </div>
            </form>
        </div>
    );
}

export default UpdateProductPage;
